
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.828 3.879L6.707 6l2.121 2.121-.707.707L6 6.708l-2.122 2.12-.707-.707 2.122-2.12L3.17 3.878l.707-.707L6 5.293 8.12 3.172l.707.707z","fill":"#fff"}})])
          )
        }
      }
    